import React from 'react';
import PropTypes from 'prop-types';
import Col from 'kepler/lib/components/Col';

const AppDetailContentDescriptionPoint = props => {
  const { icon, title, point, isDesktop } = props;

  return (
    <Col
      className="marketplace-fulldescription-point"
      style={{ width: isDesktop ? '50%' : '100%' }}
    >
      <span className={`points-icon-${icon} points-icon`}></span>
      <div className="marketplace-fulldescription-point-content">
        <h5>{title}</h5>
        <p>{point}</p>
      </div>
    </Col>
  );
};

AppDetailContentDescriptionPoint.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  point: PropTypes.string,
  isDesktop: PropTypes.bool
};

export default AppDetailContentDescriptionPoint;
